import React from 'react';

import orderBy from 'lodash/orderBy';
import propTypes from 'prop-types';
import accountPropTypes from 'apps/account/propTypes';
import Modal from 'common/components/modals/Modal';
import QuickShopContent from './QuickShopContent';

export default class QuickShopModal extends React.Component {
  static propTypes = {
    selectedVariant: accountPropTypes.ProductVariant,
    changeSelectedVariant: propTypes.func.isRequired,
    closeQuickShopModal: propTypes.func.isRequired,
    isOpen: propTypes.bool.isRequired,
    variants: propTypes.array,
  };

  handleCloseModal = () => {
    this.props.closeQuickShopModal();
  };

  sortByNicotineAndPodCount = variants => {
    const podSortKey = variant => parseInt(variant.podCount);
    const nicotineSortKey = variant => parseFloat(variant.nicotineStrength);
    return orderBy(variants, [podSortKey, nicotineSortKey], ['desc', 'desc']);
  };

  componentDidUpdate(prevProps) {
    const { variants, changeSelectedVariant } = this.props;

    if (variants && variants !== prevProps.variants) {
      changeSelectedVariant(this.sortByNicotineAndPodCount(variants)[0]);
    }
  }

  render() {
    const { selectedVariant, isOpen } = this.props;

    return (
      <div>
        <Modal
          isOpen={isOpen}
          onRequestClose={this.handleCloseModal}
          className={'quickShopModal gray-white-background'}
        >
          {selectedVariant && (
            <React.Fragment>
              <div className={'quickShopModal__image-container'}>
                <img
                  className={'quickShopModal__image'}
                  src={selectedVariant && `${selectedVariant.imageUrl}?h=500`}
                />
              </div>
              <QuickShopContent showDetailsLink={true} {...this.props} />
            </React.Fragment>
          )}
        </Modal>
      </div>
    );
  }
}
